import { ISelfServMeta, SelfServData, SubscriberComponent } from '@aa/common';
import { QnaNavigationService } from './qna-navigation.service';
import { QnaStage } from '@aa/selfserv/shared';

export class AbstractQnaComponent extends SubscriberComponent {

  public readonly meta: ISelfServMeta;
  public data: SelfServData;

  constructor(public readonly navigation: QnaNavigationService,
              public initialTitle: string,
              public readonly stage: QnaStage = QnaStage.None) {
    super();

    this.meta = this.navigation.meta;
    if (!this.meta) {
      throw Error('selfserv meta not set');
    }

    this.data = this.navigation.data;
    if (!this.data) {
      throw Error('selfserv data not set');
    }

    // TODO: look at alternative ways to handle this e.g. RouterGuard
    // It would be better if it could be done before the component loads
    this.navigation.setTitle(initialTitle);
    this.navigation.setStage(stage);
  }
}
